import * as actions from './actions';
import * as selectors from './selectors';

export const Preferences = { ...actions, ...selectors };
export { preferences } from './reducer';
export { PreferencesAppState } from './types';
